<template>
  <div class="myinfo">
    <template v-if="typeList.length > 0">
      <div class="tab" v-for="item in typeList" :key="item.id">
        <div class="left">
          <div class="title" :style="!item.isCanDo ? 'color: #999999;' : ''">
            <div
              class="line"
              :style="!item.isCanDo ? 'background: #999999;' : ''"
            ></div>
            {{ item.dict.type }}
          </div>
          <div class="time">
            <img src="./imagas/changeState/icon_1.png" v-if="item.isCanDo" />
            <img src="./imagas/changeState/icon_2.png" v-else />
            申请时段： {{ item.startTime }}~{{ item.endTime }}
          </div>
        </div>
        <div
          class="right"
          :style="!item.isCanDo ? 'background: #999999;' : ''"
          @click="open(item)"
        >
          去申请
        </div>
      </div>
    </template>
    <a-empty v-else>
      <span slot="description"> 暂无异动计划 </span>
    </a-empty>
    <a-modal v-model="visible" title="申请说明" width="1000px">
      <template slot="footer">
        <div style="text-align: center">
          <a-button
            key="submit"
            type="primary"
            @click="handleOk"
            class="modal_sub"
          >
            开始办理
          </a-button>
        </div>
      </template>
      <div v-html="description"></div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "ChangeStatefirst",
  data() {
    return {
      typeList: [],
      visible: false,
      description: null,
      timeId: null,
    };
  },
  created() {
    this.getTypes();
  },
  methods: {
    async getTypes() {
      let res = await this.axios.get(`/biz/archive/apply/types`);
      this.typeList = res.result;
    },
    async open(item) {
      if (!item.isCanDo) return;
      this.timeId = item.id;
      let res = await this.axios.get(`/biz/archive/apply/timeInfo`, {
        params: { timeId: item.id },
      });
      const { result } = res;
      if (result.description) {
        this.description = result.description;
        this.visible = true;
      } else {
        this.handleOk();
      }
    },
    handleOk() {
      this.$emit("show", { id: this.timeId });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.myinfo {
  background: #fff;
  padding: 28px;
  padding-top: 12px;
  margin-top: 20px;

  .tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 0;
    border-bottom: 1px solid #EFEFEF;
    flex: 1;

    .left {
      display: flex;
      align-items: center;

      .title {
        display: flex;
        align-items: center;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #495057;
        line-height: 32px;
        width: 140px;

        .line {
          width: 4px;
          height: 15px;
          border-radius: 2px;
          margin-right: 10px;
          background: $bgColor;
        }
      }

      .time {
        display: flex;
        align-items: center;
        margin-left: 62px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #999999;
        line-height: 32px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 10px;
        }
      }
    }

    .right {
      width: 80px;
      height: 31px;
      border-radius: 15px;
      text-align: center;
      line-height: 31px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      background: $bgColor;
      cursor: pointer;
    }
  }
}

.modal_sub {
  background: $bgColor;
  border: $bgColor;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/ChangeStatefirst.vue